export const PalettePrimary = '#1D184C'
export const PalettePrimaryLight = '#fff'
export const PalettePrimaryLightLight = '#fff'
export const PaletteGreyLight = '#A3A3A3'

export const PaletteSecondary = '#EC5A26'
